module.exports = "/lucky-balls/img/bonus_green/footer.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/footer.png
// module id = 939
// module chunks = 0